(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faq"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function(){
  $('.faq-question').on('click keypress', function(e) {
    if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
      var $item = $(this).closest('.faq-item');
      var $answer = $item.find('.faq-answer');
      var $arrowDown = $(this).find('.arrow-down');
      var $arrowUp = $(this).find('.arrow-up');

      $item.toggleClass('active');
      $answer.slideToggle();

      // Toggle arrow icons
      $arrowDown.toggle();
      $arrowUp.toggle();
    }
  });
});


  } catch(e) { console.error(e); }
})();
})();
